import { createApp, h } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import createRouter from './router'
import { i18n } from './i18n'
import { globalCookiesConfig } from 'vue3-cookies'
import * as Sentry from '@sentry/vue'
import { Channel, plugins, utils, piniaStoreModules } from 'frontendcommon-3'
import { useCommonAuth, useMicros } from './store'
import { STORAGE_LANG_KEY, DEFAULT_LANGUAGE, LANGUAGE_OBJ_CONFIG } from '@/config'
import { dashboardKey, config } from '@/dashboards'
import { getBreakPoints } from './utils/layout'
import 'frontendcommon-3/dist/frontendcommon-3.css'
import '@/assets/app.css'
import './lordicons'

const { i18nUtils: { loadLocaleMessages } } = utils
const sentryEnv = process.env.VUE_APP_SENTRY_ENV

if (dashboardKey === 'farmapremium') {
  // TODO: check if this flow is still needed
  globalCookiesConfig({
    path: '/',
    domain: '.farmapremium.es',
    secure: '',
    sameSite: 'Lax'
  })
}

const urlParams = new URLSearchParams(window.location.search)
const urlLanguage = urlParams.get('lang')?.toLocaleLowerCase()
const storageLocale = localStorage.getItem(STORAGE_LANG_KEY)
const queryLang = urlLanguage || storageLocale || DEFAULT_LANGUAGE
// axios.defaults.headers.common.language = queryLang.split('_').join('-')

const pinia = createPinia()
const commonStore = piniaStoreModules.useCommon(pinia)
const shellConfigStore = piniaStoreModules.useShellConfig(pinia)
const commonAuthStore = useCommonAuth(pinia)
const microsStore = useMicros(pinia)

commonAuthStore.SET_LANGUAGE(queryLang)
shellConfigStore.setShellConfig({ URLS: config, userInfo: {} })

const app = createApp({
  data: () => ({ props: { } }),
  render () {
    return h(App, { ...this.props })
  },
  mounted () {
    const channel = new Channel()
    channel.onShellLoadMicro(({ detail }) => {
      microsStore.loadMicro(detail)
    })
    const updateBreakpoint = () => {
      const layoutData = getBreakPoints()
      commonStore.updateBreakpoints(layoutData)
    }
    window.addEventListener('resize', updateBreakpoint)
    updateBreakpoint()
  }
})

const router = createRouter()
app.use(router)
  .use(pinia)
  .use(i18n)
  .use(plugins.DesignSystemPlugin)

if (sentryEnv) {
  Sentry.init({
    app,
    dsn: 'https://7cc4633b914345fcb3fa7ea453adfd07@sentry.farmapremium.es/10',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],
    environment: sentryEnv,
    tracesSampleRate: 1.0
  })
}

const langToQuery = LANGUAGE_OBJ_CONFIG[queryLang] || 'es'
i18n.global.locale.value = langToQuery
loadLocaleMessages(i18n, langToQuery, config.TRANSLATIONS_ROUTE).then(() => {
  app.mount('#app')
})
